/* eslint-disable import/prefer-default-export */
import { postAsyncWithTokenFormData } from "./requestWithToken";

const queryUrl = `${process.env.REACT_APP_API}get-list-review-picker`;

export async function getReviewsRes(limit, searchName, page) {
  try {
    const data = new FormData();
    data.append("page", page);
    data.append("limit", limit);
    data.append("search", searchName);
    const response = await postAsyncWithTokenFormData(queryUrl, data);
    return response.data;
  } catch (error) {
    return null;
  }
}
